export const SET_FORMULARIO = "[FORMULARIO] SET_FORMULARIO";
export const SET_RESPOSTA = "[FORMULARIO] SET_RESPOSTA";
export const LOADING_FORMULARIO = "[FORMULARIO] LOADING_LIST_FORMULARIO";
